'use client';

export const config = {
    defaultData: {
        id: '', // 活动id
        backgroundColor: '#F3F4F7',
        bgImage: '',
        mobileBgImage: '',
        kvImage: '',
        titleColor: '#000',
        subTitleColor: '#000',
        themeColor: '#000',
        frontImage: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1730107677448/%E5%8D%A1%E7%89%8C_%E6%AD%A3%E9%9D%A2.png',
        backImage: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1729842129304/%E5%8D%A1%E7%89%8C_%E8%83%8C%E9%9D%A2.png',
        prizeFontColor: '#000',
        loginType: 'page',
    },
};

export type DicType = {
    label?: string | number;
    value: string | undefined;
};

export const OtherOpthions: DicType[] = [
    {
        value: '_others',
        label: '自定义',
    },
];

export const GrayOpthions: DicType[] = [
    {
        value: '#F3F4F7',
        label: '灰色',
    },
    ...OtherOpthions,
];

export const BlackOpthions: DicType[] = [
    {
        value: '#000',
        label: '黑色',
    },
    ...OtherOpthions,
];
